module.exports = __webpack_public_path__ + "img/name_card_cord.png";